import React from 'react';
import Information from '../components/modals/common/Information';
import { messageUtility } from '../utilities/messageUtility';

export class ErrorNotSelectedField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogStatus: true,
    };
  }
  closeDialog = () => {
    this.setState(
      {
        dialogStatus: false,
      },
      () => {
        window.location.href = '/conference/Fields/0/0/0:1/0:0';
      }
    );
  };

  render() {
    return (
      <Information
        visible={this.state.dialogStatus}
        title={'現場が未選択です'}
        message={messageUtility.getMessage('E-001-400')}
        buttonText={messageUtility.getMessage('I-000-017')}
        onClose={() => this.closeDialog()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ErrorNotSelectedField.jsx